module.exports = __webpack_public_path__ + "media/images/new-year/newyear-2-template-az-acc0b4f6572b25f6b957e569af968248.png";